const baseUrl = "/"
// const baseUrl = "http://185.31.160.246:5000/"
// const baseUrl = "/"
const url = (path) => {
  return baseUrl + path
}

export const loginApi = url("ukm/v1/login")
export const ecpLoginApi = url("ukm/v1/auth")
export const registrationApi = url("ukm/v1/owner")
export const ukmApi = url("ukm/v1/check")
export const emissionsApi = url("ukm/v1/emission")
export const marksApi = url("ukm/v1/marks")
export const productListApi = url("ukm/v1/productList")
export const productApi = url("ukm/v1/product")
export const companyApi = url("ukm/v1/company")
export const storeApi = url("ukm/v1/store")
export const storeListApi = url("ukm/v1/storeList")
export const employeeApi = url("ukm/v1/employee")
export const employeeListApi = url("ukm/v1/employeeList")
export const aggregateApi = url("ukm/v1/aggregate")
export const getInfoApi = url("api/xinInfo/v1")
export const ismptApi = url("ukm/v1/ismpt")
export const terminalApi = url("ukm/v1/terminal")
export const terminalListApi = url("ukm/v1/terminalList")
export const emissionCodesApi = url("ukm/v1/ismpt/emissionCodes")
export const invoiceListApi = url("ukm/v1/invoiceList")
export const incomingInvoiceListApi = url("ukm/v1/incomingInvoiceList")
export const invoiceApi = url("ukm/v1/invoice")
export const xmlInvoiceApi = url("ukm/v1/invoice/xml")
export const invoiceItemsApi = url("ukm/v1/invoice/items")
export const invoiceGetDataApi = url("ukm/v1/invoice/getData")
export const invoiceXlsxApi = url("ukm/v1/invoice/xlsx")
export const signXmlApi = url("ukm/v1/test/xml")
export const testApi = url("ukm/v1/test")
